'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaICursor = function FaICursor(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.6 2.9q-7.2 0-7.2 5v9.2h2.9v2.9h-2.9v12.1q0 5 7.2 5h1.4v2.9h-1.4q-6.1 0-8.6-3.3-2.5 3.3-8.6 3.3h-1.4v-2.9h1.4q7.2 0 7.2-5v-12.1h-2.9v-2.9h2.9v-9.2q0-5-7.2-5h-1.4v-2.9h1.4q6.1 0 8.6 3.3 2.5-3.3 8.6-3.3h1.4v2.9h-1.4z' })
        )
    );
};

exports.default = FaICursor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/i-cursor.js
// module id = 836
// module chunks = 168707334958949